<template>
    <div>
        <Form :label-width="100" :model="formData" class="clearfix" ref="baseform">
            <Col span="24">
                <FormItem :label="$t('global.common.channel', { defaultValue: '渠道' })" >
                    <div>{{formData.accountFlag}}</div>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='SellerSKU' >
                    {{formData.sellerSku}}
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='Asin' >
                    {{formData.asin}}
                </FormItem>
            </Col>

            <Col span="24">
                <FormItem label='Listing Price' prop="listingPrice" :rules="required" >
                    <vInput v-model="formData.price"></vInput>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='Cost Price' prop="costPrice" :rules="required" >
                    <vInput v-model="formData.costPrice"></vInput>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='Payment Price' prop="paymentPrice" :rules="required" >
                    <vInput v-model="formData.paymentPrice"></vInput>
                </FormItem>
            </Col>

        </Form>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import {
    HttpGetChannelOne,
    HttpChangeVcPrice
} from '@/service/products/channel'
import {
	HttpGetProductsOne,
} from '@/service/products/allproducts'
import { HttpVsSkuList } from '@/service/boss/allot';
import erpSkuInput from '@components/templates/erpskuinput.vue';
import { mapState, mapGetters } from "vuex";
export default {
    props:['itemid'],
    components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
    data(){
        return {
            loading1:false,
            formData:{},
            formList:[],
            erpSkusList:[],
            showzuhe:false,
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
        }
    },
    created(){
        this.getDetail()
    },
    computed:{
        ...mapState('boss', ['products', 'accountTypes', 'accounts']),
    },
    methods:{
        getDetail(){
            HttpGetChannelOne({
				id:this.itemid
			}).then(res=>{
                this.formData = res.data;
                // console.log(res.data,'98989')
				this.handleData(res.data)

			},err=>{

			})
        },
        handleData(data){
            // console.log(data.erpSku)
            this.formList = data.productChannelRelateList
            if(data.type=='bundle'){
                this.showzuhe = true
                // 为组合产品就置空
                this.$set(this.formData,'erpSku','')
            }
        },
        submit(){
            // console.log(this.formList)
            // console.log(this.formData)
            let data = {
                orgId:global.SYSID,
                id:this.formData.id,
                price:this.formData.price,
                costPrice:this.formData.costPrice,
                paymentPrice:this.formData.paymentPrice,
            }
            // if (this.formData.type == 'bundle') {
            //     this.$VMessage.warning('组合产品类型下，可能会存在项目不一致的情况！')
            // }

            HttpChangeVcPrice({
                ...data
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
                this.$emit('on-update')
            },err=>{

                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>
